import { Chip, cssColorValue, cssSpacing } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { MAX_CONTENT_SCREEN_WIDTH, MD_GRID_MAX_WIDTH, ONE_COLUMN_MAX_WIDTH, TWO_COLUMN_MAX_WIDTH, } from '../../../Grid';
export const Chips = styled.div `
  margin-bottom: -8px;
`;
export const Spacer = styled.div `
  @media (max-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
    padding-inline-end: ${cssSpacing('looser-3')};
  }
  @media (max-width: ${MD_GRID_MAX_WIDTH}) {
    padding-inline-end: ${cssSpacing('looser-3')};
  }
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-inline-end: ${cssSpacing('looser-3')};
  }
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    padding-inline-end: ${cssSpacing('base')};
  }
`;
export const ChipWrapper = styled.div `
  display: flex;
  .selected {
    background-color: ${cssColorValue('textBase')} !important;
    color: ${cssColorValue('backgroundBase')};
  }
`;
export const StyledChip = styled(Chip) `
  :active {
    background-color: ${cssColorValue('backgroundTintedBase')} !important;
  }
`;
